import { render, staticRenderFns } from "./cambioTercero.vue?vue&type=template&id=416d6cfd&"
import script from "./cambioTercero.vue?vue&type=script&lang=js&"
export * from "./cambioTercero.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports